export function goToElement(hash: string) {
  if (!hash) return;

  const sectionEl = document.querySelector(hash);

  if (sectionEl) {
    sectionEl.scrollIntoView({ behavior: 'smooth' });
  }
}
